// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import {
  Field,
  type FormProps,
  formValueSelector,
  reduxForm,
} from 'redux-form';

import { bindActionCreatorsForm } from 'util/safeDispatch';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import localizedStrings from 'util/localizedStrings';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';
import { getActivePanelId } from 'state/selectors';
import type { Dispatch } from 'state/types';
import { DELETE_USER_PANEL_ID } from 'util/constants';
import CheckRadio from 'view/Forms/BulmaCheckRadio';

type Props = {
  activePanelId: ?string,
  callback: boolean => void,
  privateGalleries: string,
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
} & FormProps;

class DeleteUserDialog extends Component<Props> {
  submit: Function;

  constructor() {
    super();

    this.submit = this.submit.bind(this);
  }

  submit(data) {
    this.props.callback(data.privateGalleries === 'delete');
    this.props.hideDialogPanel();
  }

  isOkEnabled() {
    return true;
  }

  render() {
    const {
      activePanelId,
      privateGalleries,
      handleSubmit,
      hideDialogPanel,
      intl: { formatMessage },
    } = this.props;

    return (
      <DialogPanel
        activePanelId={activePanelId}
        closeAfterSave={false}
        contentStyle={{ width: '650px', height: null }}
        customButtonText={formatMessage(localizedStrings.DELETE)}
        dialogFocusId="public"
        hideDialogPanel={hideDialogPanel}
        isOkEnabled={this.isOkEnabled}
        onSave={handleSubmit(this.submit)}
        panelId={DELETE_USER_PANEL_ID}
        panelTitle={formatMessage(localizedStrings.USER_DELETE_CONFIRM)}
        showCancel
        dataTestName="remove-user-modal"
      >
        <div className="portfolio-form-container">
          <p>
            <FormattedMessage
              {...localizedStrings.USER_DELETE__GALLERY_PROMPT_1}
            />
          </p>
          <p>
            <FormattedMessage
              {...localizedStrings.USER_DELETE__GALLERY_PROMPT_2}
            />
          </p>
          <br />
          <p>
            <FormattedMessage
              {...localizedStrings.USER_DELETE__GALLERY_PROMPT_3}
            />
          </p>
          <div style={{ height: '0.5em' }} />
          <div className="control is-indented">
            <div className="field">
              <Field
                component={CheckRadio}
                fieldValue={privateGalleries}
                id="public"
                label={formatMessage(localizedStrings.USER_DELETE__MAKE_PUBLIC)}
                name="privateGalleries"
                type="radio"
                value="public"
              />
              <Field
                component={CheckRadio}
                fieldValue={privateGalleries}
                id="private"
                label={formatMessage(
                  localizedStrings.USER_DELETE__DELETE_PRIVATE
                )}
                name="privateGalleries"
                type="radio"
                value="delete"
              />
            </div>
          </div>
        </div>
      </DialogPanel>
    );
  }
}

const form = reduxForm({
  form: DELETE_USER_PANEL_ID,
  initialValues: {
    privateGalleries: 'public',
  },
})(DeleteUserDialog);

const selector = formValueSelector(DELETE_USER_PANEL_ID);
export default connect(
  state => ({
    activePanelId: getActivePanelId(state),
    privateGalleries: selector(state, 'privateGalleries'),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsForm({
      hideDialogPanel,
    })
)(injectIntl(form));



// WEBPACK FOOTER //
// ./src/view/Pages/UsersPage/DeleteUsersDialog.js